export class ProdutoGrupo {
  constructor(
    public nome: string,
    public grupo: string,
    public ordem: number,
    public selecionado: boolean,
    public exibir: boolean
  ) { }
}
